{
  "activeMiners": "Active Miners",
  "approvedRewards": "स्वीकृत रिवॉर्ड",
  "assetOverview": "खाता और संपत्तियां",
  "buyExalt": "EXALT खरीदें",
  "community": "Community",
  "dashboardSubtitle": "पेशेवर डिजिटल एसेट एक्सचेंज",
  "dashboardTitle": "डैशबोर्ड",
  "displayCurrency": "प्रदर्शन मुद्रा",
  "earn": "कमाएं",
  "estimatedExchangeWalletValue": "अनुमानित एक्सचेंज वॉलेट मूल्य",
  "exchangeActivity": "एक्सचेंज गतिविधि",
  "hideBalances": "शेष राशि छुपाएं",
  "leaderboard": "Leaderboard",
  "live": "लाइव",
  "liveMarketBoard": "● लाइव मार्केट बोर्ड",
  "loading": "लोड हो रहा है...",
  "marketCap": "मार्केट कैप",
  "marketStatus": "मार्केट स्टेटस",
  "miningPool": "माइनिंग पूल",
  "noActivityYet": "अभी कोई गतिविधि नहीं",
  "notifications": "सूचनाएं",
  "pendingRewards": "लंबित रिवॉर्ड",
  "portfolioValue": "पोर्टफोलियो वैल्यू",
  "quickActions": "क्विक एक्शन्स",
  "readyTradingWithdrawal": "ट्रेडिंग या विड्रॉल के लिए तैयार",
  "recentActivity": "हाल की गतिविधि",
  "recentOrders": "हाल के ऑर्डर",
  "refresh": "रिफ्रेश",
  "refreshDashboard": "डैशबोर्ड रीफ्रेश करें",
  "security": "सुरक्षा और सत्यापन",
  "showBalances": "शेष राशि दिखाएं",
  "submitListing": "लिस्टिंग सबमिट करें",
  "topGainer": "सबसे ज़्यादा बढ़ने वाला",
  "topLoser": "सबसे ज़्यादा गिरने वाला",
  "totalPortfolioValue": "कुल पोर्टफोलियो मूल्य",
  "trendingCoins": "ट्रेंडिंग कॉइन्स",
  "unavailable": "अनुपलब्ध",
  "viewMarketBoard": "मार्केट बोर्ड देखें",
  "waitingAdminApproval": "एडमिन स्वीकृति की प्रतीक्षा",
  "walletStatus": "वॉलेट स्थिति"
}